<div class='template'>
    <div [class.loader-hidden]="!showSpinner">
        <div class="loader-overlay" *ngIf="showSpinner">
            <i id="loader" class="fa fa-spinner fa-pulse fa-5x fa-fw"></i>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/spinner.component.html